import * as React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import {
    ButtonBase,
    makeStyles,
} from '@material-ui/core';

import HtmlContent from '../../HtmlContent';
import { elementConditionStates } from '../../../constants';

const useStyles = makeStyles(theme => ({
    accepted: {
    },
    rejected: {
    },
    actionButtonContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    actionButton: {
        width: '100%',
        padding: theme.spacing(2),
        boxShadow: theme.shadows[3],
        border: `4px solid ${theme.palette.primary.main}`,

        '$accepted &': {
            background: theme.palette.primary.main,
            borderColor: theme.palette.primary.main,
            color: theme.palette.common.white,
        },

        '$rejected &': {
            background: 'darkgrey',
            borderColor: 'transparent',
            color: 'whitesmoke',
            opacity: 1,
        },
    },
    actionButtonHtml: {
        width: '100%',
        color: 'inherit',
        '$rejected &': {
            color: 'whitesmoke',

            '& > h2, & > h3, & > h4': {
                fontWeight: theme.typography.fontWeightMedium,
            },
        },

        '$accepted &': {
            color: theme.palette.common.white,

            '& > h2, & > h3, & > h4': {
                fontWeight: theme.typography.fontWeightMedium,
            },
        },
    },
}));

const ActionButton = ({
    scaleResponse, contentState, handleResponseUpdate, question, disabled, readOnly,
}) => {
    const classes = useStyles();

    const handleClickResponse = value => () => {
        if (readOnly) return;

        handleResponseUpdate(value);
    };

    return (
        <div className={classnames(classes.actionButtonContainer, {
            [classes.accepted]: contentState === elementConditionStates.accepted,
            [classes.rejected]: contentState === elementConditionStates.rejected,
        })}
        >
            <ButtonBase
                className={classes.actionButton}
                onClick={handleClickResponse(scaleResponse ? 0 : 1)}
                disabled={disabled}
            >
                <HtmlContent html={question.question} className={classes.actionButtonHtml} />
            </ButtonBase>
        </div>
    );
};

ActionButton.propTypes = {
    handleResponseUpdate: PropTypes.func,
    question: PropTypes.object.isRequired,
    scaleResponse: PropTypes.number,
    disabled: PropTypes.bool,
    readOnly: PropTypes.bool,
    contentState: PropTypes.string,
};

ActionButton.defaultProps = {
    disabled: false,
    readOnly: false,
    handleResponseUpdate: null,
    scaleResponse: null,
    contentState: null,
};

export default ActionButton;
